import React from "react";
import { t } from "i18next";
import Layout from "./Layout";
import Deposit from "./Deposit";
import { Link, useLocation, useParams } from "react-router-dom";
import Withdraw from "./Withdraw";
import ChangePassword from "./Account/ChangePassword";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../context/AuthContext";
import RebateWeb from "./RebateWeb";
import Voucher from "./Voucher";
import RewarWeb from "./RewarWeb";
import BettingHistory from "./BettingHistory";
import Profile from "./Profile";

const AccountWebNew = () => {
  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  const { type } = useParams();
  const location = useLocation();
  let loc = location?.pathname?.split("/")[1];
  const ShowClass = (key) => {
    return `nav-btn v-btn v-btn--is-elevated v-btn--has-bg v-btn--router theme--light v-size--default ${
      key == (type || loc) ? "active-page v-btn--active" : ""
    }`;
  };

  return (
    <Layout>
      <div className="px-12 margin-desktop">
        <div>
          <div className="row bankPage-navigationBar hidden-sm-and-down">
            <div className="nav-item">
              <Link to="/bank/deposit" className={ShowClass("deposit")}>
                <span className="v-btn__content">{t("Deposit")}</span>
              </Link>
            </div>
            <div className="nav-item">
              <Link to="/bank/withdrawal" className={ShowClass("withdrawal")}>
                <span className="v-btn__content">{t("Withdrawal")}</span>
              </Link>
            </div>
            <div className="nav-item">
              <Link to="/voucher" className={ShowClass("voucher")}>
                <span className="v-btn__content">{t("Voucher")}</span>
              </Link>
            </div>
            <div className="nav-item">
              <Link
                to="/betting-history"
                className={ShowClass("betting-history")}
              >
                <span className="v-btn__content">{t("History")}</span>
              </Link>
            </div>
            <div className="nav-item">
              <Link to="/profile" className={ShowClass("profile")}>
                <span className="v-btn__content">{t("MyProfile")}</span>
              </Link>
            </div>

            <div className="nav-item">
              <Link
                to="/change-password"
                className={ShowClass("change-password")}
              >
                <span className="v-btn__content">{t("Password")}</span>
              </Link>
            </div>

            <div className="nav-item">
              <Link to="/rebate" className={ShowClass("rebate")}>
                <span className="v-btn__content">{t("InstantRebate")}</span>
              </Link>
            </div>
            <div className="nav-item">
              <Link
                to="/refer"
                className="nav-btn v-btn v-btn--is-elevated v-btn--has-bg v-btn--router theme--light v-size--default"
              >
                <span className="v-btn__content">{t("Referral")}</span>
              </Link>
            </div>
            <div className="nav-item">
              <Link
                to="/vip"
                className="nav-btn v-btn v-btn--is-elevated v-btn--has-bg v-btn--router theme--light v-size--default"
              >
                <span className="v-btn__content">{t("VIP")}</span>
              </Link>
            </div>

            <div className="nav-item">
              <Link to="/reward" className={ShowClass("reward")}>
                <span className="v-btn__content">{t("Rewards")}</span>
              </Link>
            </div>
          </div>
        </div>
        <div className="row layout-col-wrapper no-gutters">
          <div className="bank-profile-side-panel mt-4 hidden-sm-and-down col-md-2 col-2">
            <div style={{ height: "100%" }}>
              <div
                className="v-card v-sheet theme--light"
                style={{
                  "border-radius": "10px",
                  height: "100%",
                  "background-color": "white !important",
                  background: "white",
                }}
              >
                <div className="row pa-4 desktop-left-panel no-gutters">
                  <span style={{ color: "black" }}>Welcome back!</span>
                  <div className="col col-12">
                    <div className="grey-card">
                      <div className="row pa-3 card-row no-gutters">
                        <img
                          src="/assets/icon/account-grey2.svg"
                          className="left-panel-icon mr-2"
                        />
                        <span className="panel-blue-text">
                          {user?.user?.username}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col col-12">
                    <div className="grey-card">
                      <div className="row pa-3 card-row no-gutters">
                        <img
                          src="/assets/icon/bettingPass-grey.svg"
                          className="left-panel-icon mr-2"
                        />
                        <div className="col">
                          <span className="mr-1 black--text">Big Pass</span>
                          <span className="panel-blue-text">Level 1</span>
                        </div>
                        <div className="mt-2 col col-12">
                          <div
                            className="v-progress-linear v-progress-linear--rounded v-progress-linear--visible theme--light"
                            style={{ height: "4px" }}
                          >
                            <div
                              className="v-progress-linear__background grey"
                              style={{
                                opacity: "1",
                                left: "0%",
                                width: "100%",
                              }}
                            />
                            <div className="v-progress-linear__buffer" />
                            <div
                              className="v-progress-linear__determinate yellow"
                              style={{ width: "0%" }}
                            />
                          </div>
                        </div>
                        <div className="mt-1 col col-12 black--text">
                          <span className="progress-text">0/600.00</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col col-12">
                    <hr
                      role="separator"
                      aria-orientation="horizontal"
                      className="my-3 v-divider theme--light"
                    />
                  </div>
                  <div className="col col-12">
                    <div className="grey-card">
                      <div className="row pa-3 card-row no-gutters">
                        <div className="g-text black--text col col-12">
                          <span>Coin Rewards</span>
                        </div>
                        <div className="g-text col col-12">
                          <span className="panel-blue-text">0</span>
                        </div>
                        <div className="mt-2 col col-12">
                          <button
                            type="button"
                            className="nav-btn v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default"
                          >
                            <span className="v-btn__content">
                              Go To Rewards
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col col-12">
                    <div className="grey-card">
                      <div className="row pa-3 card-row no-gutters">
                        <div className="g-text black--text col col-12">
                          <span>Referral Wallet</span>
                        </div>
                        <div className="g-text col col-12">
                          <span className="panel-blue-text">৳ 0.00</span>
                        </div>
                        <div className="mt-2 col col-12">
                          <button
                            type="button"
                            className="nav-btn v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default"
                          >
                            <span className="v-btn__content">Redeem</span>
                          </button>
                        </div>
                        <div className="mt-2 black--text col col-12">
                          <p style={{ "font-size": "0.8rem" }}>
                            Earn extra cash with our exclusive referral program
                            by inviting your friends to sign up using your
                            referral code
                          </p>
                        </div>
                        <div className="mt-2 col col-12">
                          <div className="share-div">
                            <div className="referralCode-div">
                              <span className="grey-text-field ref-text panel-blue-text pa-2">
                                GMQJUZ8142
                              </span>
                            </div>
                            <div className="share-btn-div">
                              <button
                                type="button"
                                className="share-btn v-btn v-btn--icon v-btn--round theme--light v-size--default"
                              >
                                <span className="v-btn__content">
                                  <img src="/assets/icon/share-outline.svg" />
                                </span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>{" "}
          {loc == "change-password" ? (
            <ChangePassword />
          ) : loc == "rebate" ? (
            <div className="col col-10 my-12">
              <RebateWeb />
            </div>
          ) : loc == "voucher" ? (
            <Voucher />
          ) : loc == "reward" ? (
            <RewarWeb />
          ) : loc == "betting-history" ? (
            <BettingHistory />
          ) : loc == "profile" ? (
            <Profile />
          ) : (
            <div className={`bank-mid mt-4 col col-8`}>
              <div className="px-0" style={{ height: "100%" }}>
                {type == "deposit" && (
                  <div className="desktop_depo_card v-card v-sheet theme--light">
                    <Deposit />
                  </div>
                )}{" "}
                {type == "withdrawal" && (
                  <div className="desktop_depo_card v-card v-sheet theme--light">
                    <Withdraw />
                  </div>
                )}
              </div>
            </div>
          )}
          {![
            "change-password",
            "rebate",
            "voucher",
            "reward",
            "betting-history",
            "profile",
          ].includes(loc) && (
            <div className="bank-profile-side-panel hidden-sm-and-down mt-4 col-md-2 col-2">
              <div style={{ height: "100%" }}>
                <div
                  height
                  className="row desktop-right-panel hidden-sm-and-down pa-4 no-gutters"
                >
                  <div
                    className="col col-12 pb-0"
                    style={{ height: "fit-content" }}
                  >
                    <p className="right_panel_title black--text">
                      <b>Important Notice</b>
                    </p>
                    <p className="right_panel_title mb-0 black--text">
                      1. Use Official Deposit &amp; Withdrawal Channels Only:
                    </p>
                    <p className="right_panel_desc mb-0 black--text">
                      Kindly deposit or withdraw funds through the designated
                      deposit and withdrawal channels available on our website.
                      Avoid using any unofficial or third-party platforms.
                    </p>
                    <p className="right_panel_title mb-0 black--text">
                      2. Live Chat Support for Pending Transactions:
                    </p>
                    <p className="right_panel_desc mb-0 black--text">
                      If your transaction remains pending for more than 15
                      minutes, please to reach out to our 24/7 live chat
                      support. Our dedicated team is ready to assist you
                      promptly and provide real-time updates on your transaction
                      status.
                    </p>
                    <p className="right_panel_title mb-0 black--text">
                      3. Caution Regarding Cash-Outs:
                    </p>
                    <p className="right_panel_desc mb-0 black--text">
                      Do not directly cash-out to any previous e-wallet you have
                      used for transfers before. Always follow our specified
                      procedures to ensure the security and accuracy of your
                      transactions.
                    </p>
                    <p className="right_panel_title mb-0 black--text">
                      4. Use Provided E-Wallet Numbers:
                    </p>
                    <p className="right_panel_desc mb-0 black--text">
                      When initiating a cash-out, ensure that you only use the
                      e-wallet number provided by our platform. This helps us
                      process your request efficiently and minimizes the risk of
                      errors.
                    </p>
                    <p className="right_panel_desc black--text">
                      These guidelines are in place to safeguard your financial
                      transactions and protect your account. If you have any
                      questions or concerns, our customer support team is
                      available 24/7 through live chat to assist you.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default AccountWebNew;
